import React from "react";
import { Editor } from "@tinymce/tinymce-react";

// Core TinyMCE + plugins for self-hosted setup
import "tinymce/tinymce";
import "tinymce/icons/default";
import "tinymce/themes/silver";

// Plugins
import "tinymce/plugins/link";
import "tinymce/plugins/lists";
import "tinymce/plugins/code";
import "tinymce/plugins/table";
import "tinymce/plugins/preview";
import "tinymce/plugins/wordcount";

const TinyMceEditor = ({
                            name,
                            value = "",
                            onEditorChange,
                            toolbar = "undo redo | bold italic | alignleft aligncenter alignright | bullist numlist | link | code",
                            height = 300,
                            id = "self-hosted-editor",
                        }) => {
    const handleEditorChange = (content, editor) => {
        const raw = editor.getContent({ format: "text" });
        onEditorChange(content); // HTML
        // onRawChange(raw);        // Raw/plain text
    };

    return (
        <Editor
            id={id}
            value={value}
            init={{
                base_url: "/tinymce", // tells TinyMCE to load assets from /public/tinymce
                height,
                menubar: true,
                plugins: "link lists code table preview wordcount",
                toolbar,
                skin_url: "/tinymce/skins/ui/oxide", // Load self-hosted skin
                content_css: "/tinymce/skins/content/default/content.min.css",
                branding: false,
                setup: (editor) => {
                    editor.on("init", () => {
                        console.log("TinyMCE initialized (self-hosted)");
                    });
                }
            }}
            onEditorChange={handleEditorChange}
        />
    );
};

export default TinyMceEditor;
